module.exports = __webpack_public_path__ + "static/calc.1d0471b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/calc.jpg
// module id = 339
// module chunks = 35783957827783